import { ClientExperiments } from '@vestico/model';

import { getIsDeveloperPreview } from './helpers';

export class AbstractApiClient {
  /** @protected */
  readonly clientId: string;

  /** @protected */
  readonly isPreview: boolean;

  /** @protected */
  readonly iOSBundleIdentifier: string | undefined;

  /** @protected */
  readonly sdkAPIKey: string | undefined;

  /** @protected */
  readonly isSDK: boolean;

  /** @protected */
  readonly clientExperiments?: ClientExperiments;

  constructor(clientId: string, isPreview: boolean, sdkAPIKey?: string, iOSBundleIdentifier?: string, clientExperiments?: ClientExperiments) {
    this.clientId = Object.freeze(clientId);
    this.sdkAPIKey = Object.freeze(sdkAPIKey);
    this.iOSBundleIdentifier = Object.freeze(iOSBundleIdentifier);
    this.isPreview = Object.freeze(isPreview || getIsDeveloperPreview());
    this.isSDK = Object.freeze(!!sdkAPIKey && !!iOSBundleIdentifier);
    this.clientExperiments = Object.freeze(clientExperiments);
  }
}
